import classNames from 'classnames';
import React from 'react';
import { Scrollbars } from '@meitu/saas-ui';
import { BackTitle } from '@meitu/saas-ui/es/title';
import './style.less';

type Props = React.ComponentProps<'div'> & {
    title: string;
    onExit: () => void;
};

const PanelContainer: React.FC<Props> = ({ children, title, onExit, className, style = {} }) => {
    return (
        <Scrollbars autoHide>
            <div className={classNames('panel-container', className)} style={style}>
                <div className="panel-container__header">
                    <BackTitle text={title} handleBackClick={onExit} />
                </div>
                <div className="panel-container__content">{children}</div>
            </div>
        </Scrollbars>
    );
};

export default PanelContainer;
